<template lang="pug">
  v-dialog(v-model="show", width="650", persistent, ref="addForm", id="addForm")
    v-card
      v-card-title(v-if="!recordItem.id")
        h4 Новая запись
      v-card-text
        vue-form-generator(:schema="schema", :model="model")
        template(v-if="isVisibleLink && isSubmit", class="download")
          .download__wrapper
            a(:href="`/api/db/GetIpzrPlan/${this.recordItem.id}`", target="_blank", rel="noreferrer noopener").download__link Открыть ИПЗР
        MapField(v-show="showMap", ref="map", :coords="coords" @set-coords="setCoords")
        Alert(:show="isAlert", :text="alertText")
        v-layout(justify-center wrap)
          a(v-for="date in historyDates", :key="date", class="date-link", @click.stop="getHistoryHandler(date)") {{ date }}
      v-card-actions(class="pb-4")
        v-layout(justify-center wrap)
          template(v-if="isIPZR")
            v-btn(large, @click.prevent="cancel", color="blue-grey", outline).mx-2 Закрыть
            v-btn(v-if="isStatusNew", large, color="primary", @click="createRecordAndExit").mx-2 Утвердить
          template(v-if="!isIPZR")
            v-btn(
              large,
              outline,
              color="blue-grey",
              @click.prevent="cancel").mx-2 {{ edit && havePermission ? 'Отмена' : 'Закрыть' }}
            v-btn(
              v-if="havePermission",
              class="depressed-btn",
              large
              color="primary",
              :loading="loading",
              :disabled="disableSaveBtn",
              @click.prevent="createRecordAndExit").mx-2 Сохранить
            v-btn(
              v-if="!Object.keys(recordItem).length && havePermission",
              large
              class="depressed-btn",
              color="primary",
              :loader="loading",
              :disabled="disableSaveBtn",
              @click.prevent="createRecordInDb").mx-2 Сохранить и продолжить
    DeleteDialog(
      :show="viewDeleteDialog",
      dispatchType="record",
      @close-dialog="closeDeleteDialog",
      @delete-record="deleteRecord",
      @close-edit-record-dialog="closeEditRecordDialog")
      div(slot="title") Вы действительно хотите удалить эту запись?
    HistoryDialog(
      :isShowHistory="isShowHistory",
      :historyModel="historyModel",
      @close-history-modal="isShowHistory = false")
</template>

<script>
import moment from 'moment'
import axios from 'axios'
import { mapState } from 'vuex'
import MapField from '@/components/DataBase/Common/MapField'
import DeleteDialog from '../Common/DeleteDialog/DeleteDialog'
import Alert from '../Common/Alert/Alert'
import HistoryDialog from './HistoryDialog'
export default {
  components: { HistoryDialog, Alert, DeleteDialog, MapField },
  props: {
    id: {
      type: String,
      default: ''
    },
    edit: {
      type: Boolean,
      default: false
    },
    recordItem: {
      type: Object,
      default: () => ({})
    },
    show: {
      type: Boolean,
      default: false
    },
    page: {
      type: Number,
      default: 1
    },
    size: {
      type: Number,
      default: 10
    },
    name: {
      type: String,
      default: ''
    },
    historyDates: {
      type: Array,
      default: () => []
    }
  },
  name: 'AddNewRecord',
  data: () => ({
    model: {},
    schema: {},
    viewDeleteDialog: false,
    disableSaveBtn: false,
    isAlert: false,
    alertText: '',
    showMap: false,
    map: {},
    coords: [],
    idMap: null,
    isStatusNew: false,
    isIPZR: false,
    isSubmit: false,
    isVisibleLink: false,
    pin: '',
    isShowHistory: false,
    historyModel: {},
    isSignal: false
  }),
  created() {
    this.subscribeToMutations()
  },
  watch: {
    name(val) {
      this.isIPZR = (val && val === 'ИПЗР') || (val && val === 'Дети в ТЖС')
      this.isSignal = val === 'Сигнал'
    },
    show(value) {
      if (!value) {
        this.$emit('close-edit')
        this.clearData()
        this.$refs.map.destroyMap()
      } else {
        this.$nextTick(() => {
          this.$refs.map.initMap()
        })
      }
      if (this.id) {
        this.$store.dispatch('GET_SCHEMA', this.id)
      }
    },
    viewSchema: {
      deep: true,
      handler(object) {
        Object.keys(this.recordItem).length
          ? (this.model = { ...this.recordItem.model })
          : (this.model = { ...object.schema.model })
        this.schema = { ...object.schema.schema }
        Object.keys(this.model).map(item => {
          if (item.split('-')[0] === 'tyndyk') {
            delete this.model[item]
          }
        })
        Object.keys(this.model).map(item => {
          if (item.split('-')[0] === 'map') {
            this.idMap = item
            this.showMap = true

            if (this.model[item].length > 1) {
              this.coords = JSON.parse(this.model[item])
            }
          }
        })
        this.schema.fields.map((item, index) => {
          if (item.model.split('-')[0] === 'tyndyk') {
            this.schema.fields.splice(index, 1)
          }
          // if (item.label_en === 'PIN') {
          //   this.setPin(item)
          // }
        })
      }
    },
    model: {
      deep: true,
      handler(object) {
        Object.keys(object).map(item => {
          if (object[item] === 'Новый_ИПЗР') this.isStatusNew = true

          if (object[item] === 'Утвержденный_ИПЗР') {
            this.isSubmit = true
            this.isVisibleLink = true
          }

          this.validationDates(item)
        })
      }
    }
  },
  computed: {
    ...mapState({
      dbName: state => state.dbConstructor.dbSchema.name,
      viewSchema: state => state.dbConstructor.dbSchema,
      loading: state => state.db.loading.createRecord,
      havePermission: state => state.dbConstructor.dbSchema.edit
    })
  },
  methods: {
    validationDates(item) {
      if (item.includes('date')) {
        let date = this.model[item]
        if (date) {
          this.schema.fields.map(item => {
            if (item.model.split('-')[0] === 'date') {
              let minDate = moment(item.min).format('x')
              let maxDate = moment(item.max).format('x')
              if (date < minDate || date > maxDate) {
                this.isAlert = true
                this.alertText = `Указанная дата не попадает в установленный диапазон.
                 Минимальное значение: ${moment(item.min).format('LL')},
                 Максимальное значение: ${moment(item.max).format('LL')}`
              } else {
                this.isAlert = false
                this.alertText = ''
              }
            }
          })
        }
      }
    },
    // setPin(item) {
    //   let field = item.model
    //   for (let el in this.model) {
    //     if (el === field) {
    //       this.pin = this.model[el]
    //     }
    //   }
    // },
    setCoords(coords) {
      if (coords[0].length > 1) this.model[this.idMap] = JSON.stringify(coords)
    },
    openDeleteDialog() {
      this.viewDeleteDialog = true
    },
    closeDeleteDialog() {
      this.viewDeleteDialog = false
    },
    cancel() {
      this.$emit('close-edit')
      this.$emit('clear-history-dates')
      this.clearData()
    },
    deleteRecord() {
      this.$store.dispatch('DELETE_RECORD', this.recordItem.id).then(() => {
        this.$store.dispatch('GET_DB_RECORDS_LIST', {
          id: this.id
        })
      })
    },
    closeEditRecordDialog() {
      this.$emit('close-edit')
      this.$emit('clear-history-dates')
    },
    createRecordInDb() {
      if (!this.isAlert && !this.alertText) {
        this.$store.dispatch('CREATE_NEW_RECORD_IN_DB', {
          dbId: this.id,
          model: this.model
        })
      }
    },
    changeStatus() {
      for (let el in this.model) {
        if (this.model[el] === 'Новый_ИПЗР') {
          this.model[el] = 'Утвержденный_ИПЗР'
        }
      }
    },
    async createRecordAndExit() {
      if (Object.keys(this.recordItem).length) {
        await this.changeStatus()
        await this.$store.dispatch('EDIT_RECORD', {
          id: this.recordItem.id,
          dbId: this.id,
          model: this.model,
          page: this.page,
          size: this.size
        })
      } else {
        await this.$store.dispatch('CREATE_NEW_RECORD_AND_EXIT', {
          dbId: this.id,
          model: this.model
        })
      }
    },
    clearData() {
      this.model = {}
      this.schema = {}
      this.isAlert = false
      this.alertText = ''
      this.showMap = false
      this.idMap = null
      this.isStatusNew = false
      this.isVisibleLink = false
      this.isSubmit = false
      this.$emit('clear-history-dates')
    },
    showAlert(error) {
      this.alertText = error
      this.isAlert = true
    },
    subscribeToMutations() {
      this.$store.subscribe((mutation, state) => {
        switch (mutation.type) {
          case 'CREATE_NEW_RECORD_AND_EXIT_SUCCESS':
            this.$emit('close-edit')
            this.clearData()
            break
          case 'CREATE_NEW_RECORD_SUCCESS':
            this.model = {}
            this.isAlert = false
            this.alertText = ''
            break
          case 'EDIT_RECORD_SUCCESS':
            this.$emit('close-edit')
            this.clearData()
            break
          case 'CREATE_NEW_RECORD_AND_EXIT_ERROR':
            this.showAlert(this.$store.state.db.errors.createRecordAndExitError)
            break
          case 'CREATE_NEW_RECORD_ERROR':
            this.showAlert(this.$store.state.db.errors.newRecordResponseError)
            break
          case 'EDIT_RECORD_ERROR':
            this.showAlert(this.$store.state.db.errors.editRecordError)
            break
        }
      })
    },
    getHistoryHandler(date) {
      axios({
        method: 'GET',
        url: '/api/history/get-record',
        params: { recordId: this.recordItem.id, dateTime: date }
      })
        .then(response => {
          this.historyModel = response.data.result
          this.isShowHistory = true
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.v-card {
  &__title {
    padding-bottom: 0;
    h4 {
      font-size: 24px;
      margin: 0 auto;
    }
  }
  &__actions {
    .v-btn {
      border-radius: 4px;
    }
    .v-btn--active:before,
    .v-btn:focus:before,
    .v-btn:hover:before {
      opacity: 0.25;
    }
  }
  &__text {
    .download {
      &__wrapper {
        border: 1px solid #ccc;
        background: #fbfbfb;
        border-radius: 5px;
        padding: 8px 16px;
        margin: 16px 0;
        /*text-align: center;*/
      }
    }
    .date-link {
      margin: 0 12px;
      text-decoration: underline;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DataBase/AddNewRecord.vue